import moment from "moment"
import * as R from "ramda"

export const localStorageSafe = typeof localStorage !== "undefined"

export const removeNull = data =>
  Object.keys(data)
    .filter(e => data[e] !== null)
    .reduce((o, e) => {
      o[e] = data[e]
      return o
    }, {})

export const formatDateTime = dateTime =>
  moment(dateTime)
    .locale("th")
    .format("LL")

export const getMinValueByKey = (arr, key) =>
  arr.reduce((prev, curr) => (prev[key] < curr[key] ? prev : curr), 0)

export const getMinValueByPath = (arr, path) =>
  arr.reduce(
    (prev, curr) =>
      parseFloat(R.path(path, prev)) < parseFloat(R.path(path, curr))
        ? prev
        : curr,
    0
  )

export const getMaxValueByKey = (arr, key) =>
  arr.reduce((prev, curr) => (prev[key] > curr[key] ? prev : curr), 0)

export const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export const generateOption = elements => {
  const result = []
  elements.forEach(element =>
    result.push({
      key: element,
      text: element,
      value: element
    })
  )
  return result
}
export const isLogin = () =>
  localStorageSafe && localStorage.getItem("run-24-hrs-token")

export const zeroPad = (num, places) => {
  const zero = places - num.toString().length + 1
  return Array(+(zero > 0 && zero)).join("0") + num
}

export const calCulatePace = (time, distance) =>
  (time / distance || 0).toFixed(2)

export const startSubmitRun = race => {
  const startTime = R.path(["start_time"], race)
  return moment().format() > startTime
}

export const endSubmitRun = race => {
  const endSubmitTime = R.path(["last_submit_time"], race)
  return moment().format() > endSubmitTime
}

export const endRegisterRace = race => {
  const startTime = R.path(["end_register_time"], race)
  return moment().format() > startTime || R.path(["close_registration"], race)
}

export const endEvent = event => {
  const endTime = R.path(["end_time"], event)
  return moment().format() > endTime || event.close_order
}

export const getImageUrl = url =>
  url.includes("http") ? url : `https://api.run24hrs.com${url}`



// WEBPACK FOOTER //
// /opt/build/repo/src/utils/index.js